import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import StaggeredMenu from './StaggeredMenu';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setScrolled(scrollPosition > 50);
    };

    // Use Lenis scroll event if available, otherwise fallback to native
    if (window.lenis) {
      window.lenis.on('scroll', handleScroll);
      return () => window.lenis.off('scroll', handleScroll);
    } else {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollToSection = (href, isExternal = false) => {
    // Check if we're on a music-related page (single track or music list)
    const isMusicPage = window.location.pathname.startsWith('/music');

    if (isExternal) {
      window.location.href = href;
      return;
    }

    // If we're on a music page and the link is internal, redirect to main page first
    if (isMusicPage && !isExternal) {
      // For internal links, redirect to main page with the hash
      window.location.href = `/${href}`;
      return;
    }

    const id = href.startsWith('#') ? href : `#${href}`;
    const element = document.querySelector(id);
    if (element) {
      // Use Lenis smooth scroll if available, otherwise fallback to native
      if (window.lenis) {
        window.lenis.scrollTo(element, { offset: -80 });
      } else {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const menuItems = [
    { label: 'Home', ariaLabel: 'Go to home page', link: '#home', isExternal: false },
    { label: 'About', ariaLabel: 'Learn about me', link: '#about', isExternal: false },
    { label: 'Projects', ariaLabel: 'View my projects', link: '#projects', isExternal: false },
    { label: 'Research', ariaLabel: 'See my research', link: '#research', isExternal: false },
    { label: 'Apps', ariaLabel: 'Check out my apps', link: '#apps', isExternal: false },
    { label: 'Music', ariaLabel: 'Listen to my music', link: '/music', isExternal: true },
    { label: 'Birthdays', ariaLabel: 'Birthday tracker app', link: '/birthdays', isExternal: true },

    { label: 'Contact', ariaLabel: 'Get in touch', link: '#contact', isExternal: false }
  ];

  const socialItems = [
    { label: 'GitHub', link: 'https://github.com/kryptik-dev' },
    { label: 'Instagram', link: 'https://www.instagram.com/kryptikk.dev/' },
    { label: 'WhatsApp', link: 'https://wa.me/27766934588' }
  ];

  return (
    <>
      <StaggeredMenu
        position="right"
        items={menuItems}
        socialItems={socialItems}
        displaySocials={true}
        displayItemNumbering={true}
        menuButtonColor="#f9fafb"
        openMenuButtonColor="#9ca3af"
        changeMenuColorOnOpen={true}
        colors={['#0a0a0a', '#111111', '#9ca3af']}
        logoUrl={null}
        accentColor="#9ca3af"
        onMenuOpen={() => console.log('Menu opened')}
        onMenuClose={() => console.log('Menu closed')}
        onItemClick={(item) => scrollToSection(item.link, item.isExternal)}
      />

      {/* Progress Indicator */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-green-gradient z-50 origin-left"
        style={{ transformOrigin: 'left' }}
        initial={{ scaleX: 0 }}
        animate={{ scaleX: scrolled ? 1 : 0 }}
        transition={{ duration: 0.2 }}
      />
    </>
  );
};

export default Navigation;